__turbopack_context__.v({
  "card": "wFgKGW_card",
  "card--clickable": "wFgKGW_card--clickable",
  "card--elevation-0": "wFgKGW_card--elevation-0",
  "card--elevation-1": "wFgKGW_card--elevation-1",
  "card--elevation-2": "wFgKGW_card--elevation-2",
  "card--no-radius": "wFgKGW_card--no-radius",
  "card--secondary": "wFgKGW_card--secondary",
  "card--small-radius": "wFgKGW_card--small-radius",
});
